module.exports = __webpack_public_path__ + "static/media/autonomous_vision_052123.f96432b0.png";